import { render, staticRenderFns } from "./editMangelPrioritaet.vue?vue&type=template&id=f9711664"
import script from "./editMangelPrioritaet.vue?vue&type=script&lang=js"
export * from "./editMangelPrioritaet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports